export default "__VITE_ASSET__D8hJF7wx__"